import EnvironmentSettings from "../../Classes/Models/EnvironmentSettings";
import UsersApi from "./UsersApi";
import TenantManager from "./TenantManager";

class PartitionApi {
  constructor() {
    this.baseUrl =
      EnvironmentSettings.Environment === "dev"
        ? EnvironmentSettings.LocalUrl
        : EnvironmentSettings.LiveUrl;
  }

  GetAllFeaturesUrl = "FeatureManagement/GetAll";
  UpdateFeaturesUrl = "FeatureManagement/UpdateFeatures";
  CreateFeatureUrl = "FeatureManagement/Create";

  async GetAllFeatures() {
    const res = await fetch(this.baseUrl + this.GetAllFeaturesUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify({}),
    });
    let data = await res.json();
    return data;
  }

  async UpdateFeatures(enabledIds) {
    const res = await fetch(this.baseUrl + this.UpdateFeaturesUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(enabledIds),
    });
    let data = await res.json();
    return data;
  }

  async CreateFeature(featureData) {
    const res = await fetch(this.baseUrl + this.CreateFeatureUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${await UsersApi.GetToken()}`,
        tenant: TenantManager.getTenant(await UsersApi.GetToken()),
      },
      body: JSON.stringify(featureData),
    });
    return await res.json();
  }
}

export default new PartitionApi();
